module.exports = __webpack_public_path__ + "static/img/consumer-h5-1.87163bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/consumer-h5-1.png
// module id = ibaO
// module chunks = 34